export default __webpack_public_path__ + "static/media/filter_icon.1b23c10c.svg";